<script setup>

import EventHeading from "@/views/event-activities/components/EventHeading.vue";
import HeadinDesc from "@/views/event-activities/components/HeadinDesc.vue";
import EventBooking from "@/views/event-activities/EventBooking.vue";

import {getCurrentInstance, onMounted, reactive} from "vue";
const { $axios } = getCurrentInstance().appContext.config.globalProperties;
const { $endpoint } = getCurrentInstance().appContext.config.globalProperties;
const eventPageData = reactive({});

onMounted(()=>{
  $axios.get($endpoint.LoadEvent).then((resp_event_data)=>{
    Object.assign(eventPageData, resp_event_data.data);
  });
  console.log(eventPageData);
})
</script>

<template>
  <event-heading v-if="eventPageData && eventPageData.heroSliders" :carousel-items="eventPageData.heroSliders"></event-heading>
  <headin-desc></headin-desc>
  <event-booking v-if="eventPageData && eventPageData.presentation" :event-presentation="eventPageData.presentation"></event-booking>
</template>

<style scoped>

</style>